import { createDynamicThunk } from ".";

/**
 * LIST Client
 */
export const fetchClientsThunk = createDynamicThunk({
  typePrefix: "clients/fetchClientsThunk",
  useHandleSearch: true,
});

/**
 * ADD / EDIT Client
 */
export const submitClientThunk = createDynamicThunk({
  typePrefix: "clients/submitClientThunk",
  endpoint: "/clients",
  method: "POST",
});

/**
 * Fetch Processes by Deparmtent
 */
export const fetchClientsByDeptThunk = createDynamicThunk({
  typePrefix: "clients/fetchClientsByDeptThunk",
  endpoint: "/clients/findClientsByDept",
  method: "POST",
});
